/**
 * Homeground — mobile menu close-animation shim.
 *
 * Tapping the header drawer's <summary> (the morphing hamburger/X) fires
 * Horizon's toggle() handler, but the browser's native summary default
 * action then removes the <details> [open] attribute immediately —
 * cancelling the CSS close animation, which is keyed on
 * [open]:not(.menu-open) in homeground-overrides.css.
 *
 * Fix: preventDefault on the summary click only when the menu is open
 * (closing). Horizon's own reset() removes [open] after its
 * onAnimationEnd() wait, so state stays consistent. Opening is left
 * native — the default action adding [open] is required.
 */
document.addEventListener(
  'click',
  (event) => {
    if (!(event.target instanceof Element)) return;

    const summary = event.target.closest('.menu-drawer-container > summary.header__icon--menu');
    if (!summary) return;

    const details = summary.closest('details');
    if (details?.open && window.matchMedia('(max-width: 749px)').matches) {
      event.preventDefault();
    }
  },
  { capture: true }
);
